import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Alert, Button, Input } from 'reactstrap';
import { useAuth } from '../../contexts/AuthContext';

const EmailConfirmation = () => {
  const { confirmSignup, resendConfirmationCode, loading } = useAuth();
  const history = useHistory();
  const location = useLocation();
  
  // Get username and email from navigation state or URL params
  const username = location.state?.username || '';
  const email = location.state?.email || '';
  
  const [confirmationCode, setConfirmationCode] = useState('');
  const [confirmationError, setConfirmationError] = useState('');
  const [manualUsername, setManualUsername] = useState(username);
  const [manualEmail, setManualEmail] = useState(email);

  const handleConfirmSignup = async (e) => {
    e.preventDefault();
    setConfirmationError('');
    
    if (!manualUsername.trim()) {
      setConfirmationError('Username is required');
      return;
    }
    
    if (!confirmationCode.trim()) {
      setConfirmationError('Confirmation code is required');
      return;
    }
    
    const result = await confirmSignup(manualUsername, confirmationCode);
    
    if (result.success) {
      // Redirect to login page after successful confirmation
      history.push('/login', { 
        message: 'Email confirmed successfully! You can now sign in.',
      });
    } else {
      setConfirmationError(result.error || 'Failed to confirm signup');
    }
  };

  const handleResendCode = async () => {
    setConfirmationError('');
    
    if (!manualUsername.trim()) {
      setConfirmationError('Username is required to resend code');
      return;
    }
    
    const result = await resendConfirmationCode(manualUsername);
    
    if (result.success) {
      setConfirmationError('');
      // Show success message - we could add a success state if needed
    } else {
      setConfirmationError(result.error || 'Failed to resend confirmation code');
    }
  };

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">Confirm Your Email</h3>
            <h4 className="account__subhead subhead">
              Please check your email for a confirmation code
            </h4>
          </div>
          
          <form className="form" onSubmit={handleConfirmSignup}>
            {confirmationError && (
              <Alert color="danger" className="mb-3">
                {confirmationError}
              </Alert>
            )}
            
            <div className="form__form-group">
              <span className="form__form-group-label">Username</span>
              <div className="form__form-group-field">
                <Input
                  type="text"
                  value={manualUsername}
                  onChange={e => setManualUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                />
              </div>
            </div>

            <div className="form__form-group">
              <span className="form__form-group-label">Email (optional)</span>
              <div className="form__form-group-field">
                <Input
                  type="email"
                  value={manualEmail}
                  onChange={e => setManualEmail(e.target.value)}
                  placeholder="Enter your email"
                />
              </div>
            </div>

            <div className="form__form-group">
              <span className="form__form-group-label">Confirmation Code</span>
              <div className="form__form-group-field">
                <Input
                  type="text"
                  value={confirmationCode}
                  onChange={e => setConfirmationCode(e.target.value)}
                  placeholder="Enter confirmation code from email"
                  required
                />
              </div>
            </div>

            <Button 
              className="btn btn-primary account__btn account__btn--small" 
              type="submit"
              disabled={loading}
            >
              {loading ? 'Confirming...' : 'Confirm Email'}
            </Button>
            
            <Button 
              className="btn btn-outline-secondary account__btn account__btn--small" 
              type="button"
              onClick={handleResendCode}
              disabled={loading}
            >
              Resend Code
            </Button>
            
            <div className="account__help">
              <p>
                Already confirmed your email?{' '}
                <Button 
                  color="link" 
                  onClick={() => history.push('/login')}
                  className="p-0"
                >
                  Sign In
                </Button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;
